import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import DashboardLayout from './components/layout/DashboardLayout'
import Publish from './pages/Publish'
import Schedule from './pages/Schedule'
import MarkdownEditor from './pages/MarkdownEditor'
import ImageGrid from './pages/ImageGrid'
import Settings from './pages/Settings'

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -8 },
}

const pageTransition = {
  type: 'tween' as const,
  ease: [0.22, 1, 0.36, 1] as [number, number, number, number],
  duration: 0.3,
}

function AnimatedRoutes() {
  const location = useLocation()
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="flex min-h-screen"
      >
        <Routes location={location}>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Publish />} />
            <Route path="dashboard" element={<Publish />} />
            <Route path="dashboard/publish" element={<Publish />} />
            <Route path="dashboard/schedule" element={<Schedule />} />
            <Route path="dashboard/md" element={<MarkdownEditor />} />
            <Route path="dashboard/grid" element={<ImageGrid />} />
            <Route path="dashboard/settings" element={<Settings />} />
          </Route>
        </Routes>
      </motion.div>
    </AnimatePresence>
  )
}

function App() {
  return (
    <Router>
      <div className="flex min-h-screen">
        <AnimatedRoutes />
      </div>
    </Router>
  )
}

export default App
